import { EnsaioMetodo } from '@models/ensaio-metodo.model';
import axios from 'axios';

const listaEnsaiosMetodos = async (): Promise<EnsaioMetodo[]> => {
  const res = await axios.get<EnsaioMetodo[]>(`/ensaios_metodos`);
  return res.data;
};
export default {
  listaEnsaiosMetodos,
};
